export default {
  first_name: null,
  last_name: null,
  email: null,
  phone: null,
  address: null,
  country: null,
  zip_code: null,
  status: null,
  checking: null,
  checkout: null,
  time_in: null,
  time_out: null,
  nbr_adults: null,
  nbr_children: null,
  price: null,
  price_extra: null,
  cleaning: null,
  deposit: null,
  fkey_users: null,
  fkey_source: null
};



// WEBPACK FOOTER //
// ./src/app/store/modules/booking/state.js